import { isNil } from '@flowio/is';
import fiserveThreedsChallenge from '../../utilities/fiserv-3ds-challenge-action-handler';
import fiservThreedsIdentifyActionHandler from '../../utilities/fiserv-3ds-identify-action-handler';
import resolveContainer from '../../utilities/resolve-container';
export function handleAuthResultAction(action, container) {
  switch (action.discriminator) {
    case 'threeds_identify_action_details':
      {
        // fiserv
        var resolvedContainer = resolveContainer(container);

        if (isNil(resolvedContainer)) {
          return Promise.reject(new Error('handleAuthResultAction: Could not resolve container element'));
        } // eslint-disable-next-line no-param-reassign


        return fiservThreedsIdentifyActionHandler(action, resolvedContainer);
      }

    case 'threeds_challenge_action_details':
      {
        // fiserv
        var _resolvedContainer = resolveContainer(container);

        if (isNil(_resolvedContainer)) {
          return Promise.reject(new Error('handleAuthResultAction: Could not resolve container element'));
        } // eslint-disable-next-line no-param-reassign


        return fiserveThreedsChallenge(action, _resolvedContainer);
      }

    default:
  }

  return Promise.reject(new Error('handleAuthResultAction: Unmatched authorization_result_action'));
}
export default {
  handleAuthResultAction: handleAuthResultAction
};
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/payment/lib/esm/payment_methods/card/index.js
// module id = 596
// module chunks = 0 1